import App from 'components/App';
import { basename } from 'config';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import API from 'services/api';
import configureStore from 'store/configure';
import './assets/css/masterstyle.css';
import './index.css';

const store = configureStore({}, { api: new API() })

const renderApp = () => (
  <Provider store={store}>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </Provider>
)

const root = document.getElementById('app')
render(renderApp(), root)